"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
/**
 * Calculates a percentage value for the given
 * proficiency score.
 *
 * @param score         The current proficiency score.
 * @param attemptsCount The number of attempts used to calculate the proficiency score.
 */
function calculateProficiencyPercentage(score, attemptsCount) {
    if (attemptsCount === void 0) { attemptsCount = constants_1.RECENT_ATTEMPTS_COUNT; }
    // Calculate the score percentage by dividing the
    // new score by the maximum potential score for the
    // number of attempts made
    var scorePercentage = Math.round((score / (attemptsCount * constants_1.RATING_VALUES.correct)) * 100);
    return scorePercentage;
}
exports.default = calculateProficiencyPercentage;
//# sourceMappingURL=calculateProficiencyPercentage.js.map